import * as React from 'react'
import styles from '@/scopes/checkout/groups/components/styles.module.css'

export function PageLayout({ children }: React.PropsWithChildren) {
  return (
    <div
      className={
        styles.pageLayout
      }
    >
      {children}
    </div>
  )
}
